import React from 'react'

import WelcomeGuideLayout from 'components/WelcomeGuideLayout'

import Locale from './locale'

const ICON_TYPE = 'error'


export default function NotAvailableOnPlan() {
  return (
    <WelcomeGuideLayout
      description={ Locale.description }
      iconType={ ICON_TYPE }
      showButton={ false }
      title={ Locale.title }
    />
  )
}
